import React, { Component } from 'react'
import CardOferta from '@loyal_images/progressive_offer.jpg'
import CardOferta2 from '@loyal_images/card_oferta_progressiva2.png'
import CardOferta3 from '@loyal_images/win_points_iupp.png'
import { Link } from 'react-router-dom'

class AccumulatePoints extends Component {
  constructor (props) {
    super(props)

    this.state = {}
  }

  render () {
    return (
      <div className='pos-relative pt-2 px-1 scope-points'>
        <div className='container px-0'>
          <div className='row'>
            <div className='col-12 mb-2'>
              <h2 className='txt-font-title color-title'>É muito fácil acumular pontos! Quer ver como?</h2>
            </div>
            <div className='col-12 col-md-4 mb-2'>
              <img src={CardOferta} className='w-100' alt='Transferindo pontos do Sempre Presente para o iupp' />
            </div>
            <div className='col-12 col-md-4 mb-2'>
              <Link to='/pointsandcash' className='d-block'>
                <img src={CardOferta2} className='w-100' alt='Fazendo compras em nosso shopping com dinheiro.' />
              </Link>
            </div>
            <div className='col-12 col-md-4 mb-2'>
              <img src={CardOferta3} className='w-100' alt='A cada real gasto, ganhe pontos iupp.' />
            </div>
          </div>
        </div>
      </div>
    )
  }
}

export default AccumulatePoints



// WEBPACK FOOTER //
// ./src/features/AccumulatePoints/AccumulatePoints.js